export default __webpack_public_path__ + "static/media/whatWeFaceEn.44526b1a.png";